var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 9.99787C3.73952 10.4589 2.66699 11.3207 2.66699 12.3078C2.66699 13.7805 5.05481 14.9744 8.00033 14.9744C10.9458 14.9744 13.3337 13.7805 13.3337 12.3078C13.3337 11.3207 12.2611 10.4589 10.667 9.99787M12.0003 5.90778C12.0003 8.2642 9.00033 12.3078 8.00033 12.3078C7.00033 12.3078 4.00033 8.2642 4.00033 5.90778C4.00033 3.55136 5.79119 1.64111 8.00033 1.64111C10.2095 1.64111 12.0003 3.55136 12.0003 5.90778ZM9.33366 5.64111C9.33366 6.37749 8.7367 6.97445 8.00033 6.97445C7.26395 6.97445 6.66699 6.37749 6.66699 5.64111C6.66699 4.90473 7.26395 4.30778 8.00033 4.30778C8.7367 4.30778 9.33366 4.90473 9.33366 5.64111Z",
    stroke: "#1B4DFF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationActive);
export default __webpack_public_path__ + "static/media/IconLocationActive.c9d041813bd775766f9ad9a53a068025.svg";
export { ForwardRef as ReactComponent };